import { SalesInvoice } from '@ospace/schemas'
import { Opportunity } from '@ospace/schemas'

export const salesSegments = ({
  opportunities,
  sales,
}: {
  opportunities: Opportunity[]
  sales: SalesInvoice[]
}) => {
  const opportunitiesByOppNumber = opportunities.reduce(
    (acc, opportunity) => ({
      ...acc,
      [opportunity.oppNumber]: opportunity,
    }),
    {}
  ) as { [key: string]: Opportunity }

  let nextGen = {
    value: 0,
    deals: 0,
  }
  let partner = {
    value: 0,
    deals: 0,
  }
  let vendor = {
    value: 0,
    deals: 0,
  }
  let total = 0

  sales.forEach((sale) => {
    const price = +(sale.buyPriceFx || 0)
    const opportunity = sale.oppNumber ? opportunitiesByOppNumber[sale.oppNumber] : null
    if (opportunity?.programName) {
      nextGen.value += price
      if (sale.creditNote.toLowerCase() !== 'creditnote') {
        nextGen.deals++
      }
    } else if (opportunity?.partnerSourced) {
      partner.value += price
      if (sale.creditNote.toLowerCase() !== 'creditnote') {
        partner.deals++
      }
    } else {
      vendor.value += price
      if (sale.creditNote.toLowerCase() !== 'creditnote') {
        vendor.deals++
      }
    }
    total += price
  })

  return {
    total,
    nextGen,
    partner,
    vendor,
  }
}
